import {cn} from "../../../utils/utils";
import backdropErrorImg from "../../../images/backdropErrorImg.png";

import './itemTmdbBtnV2.scss';
import {Spinner} from "../index";

export type ItemTbdbBtnV2Props = {
    tmdbItem: any;
    type?: 'movie' | 'tv' | 'live' | 'episode';
    bottomInfo?: React.ReactNode;
    description?: React.ReactNode;
    onClick?: (item: any) => void;
    loading?: boolean;
    overContent?: React.ReactNode;
    width?: number;
}

const ItemTmdbBtnV2 = ({
                           tmdbItem,
                           description,
                           type,
                           bottomInfo,
                           onClick,
                           loading,
                           overContent,
                           width = 120,
                       }: ItemTbdbBtnV2Props) => {

    const handleClick = () => {
        if (!onClick) return;
        onClick(tmdbItem);
    }

    if (loading) {
        return (
            <div className="me-3" style={{width: 120}}>
                <div className="position-relative" style={{
                    width: width,
                    aspectRatio: '6/9',
                    backgroundColor: 'rgba(204,204,204,0.39)',
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Spinner className=""/>
                </div>
                <div style={{
                    marginTop: 8,
                    fontSize: 14,
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    height: 18,
                    backgroundColor: 'rgba(238,238,238,0.39)',
                    borderRadius: 4,
                }}>
                </div>
                <div style={{
                    fontSize: 12,
                    color: '#666',
                    height: 14,
                    backgroundColor: 'rgba(238,238,238,0.39)',
                    marginTop: 4,
                    borderRadius: 4,
                }}>
                </div>
            </div>
        );
    }

    const hasImage = !!(tmdbItem.poster_path || tmdbItem.backdrop_path);

    return (
        <div className={cn({"itemTmdbBtn__clickable": !!onClick})} style={{width: width}} onClick={handleClick}>
            <div className="position-relative"
                 style={{
                     width: width,
                     aspectRatio: '6/9',
                     backgroundImage: hasImage ? `url(https://image.tmdb.org/t/p/w300${tmdbItem.poster_path || tmdbItem.backdrop_path})` : `url(${backdropErrorImg})`,
                     backgroundSize: 'cover',
                     backgroundPosition: 'center',
                     borderRadius: 8,
                     boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                 }}>
                {overContent}
                {!hasImage && (
                    <div style={{
                        position: 'absolute',
                        width: '100%',
                        top: 10,
                        left: '0',
                        right: '0',
                        color: 'rgba(0,0,0,0.7)',
                        fontWeight: '500',
                        textAlign: 'center',
                        padding: 10,
                    }}>
                        {tmdbItem.title || tmdbItem.name}
                    </div>)}
                {bottomInfo && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 4,
                            right: 4,
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: 4,
                            fontSize: 12,
                            fontWeight: 'bold',
                        }}
                    >
                        {bottomInfo}
                    </div>
                )}
            </div>
            <div style={{
                marginTop: 8,
                fontSize: 14,
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}>
                {tmdbItem.title || tmdbItem.name}
            </div>
            {description && (
                <div style={{fontSize: 12, color: '#666'}}>
                    {description}
                </div>
            )}
        </div>
    );
}

export default ItemTmdbBtnV2;
